<template>
    <div class="pt-4 pb-4">
        <b-spinner v-show="loading" class="text-info my-2"></b-spinner>
        <b-form-radio
            v-if="cheapDelivery && cheapDelivery.length !== 0"
            class="mb-2 h5 font-weight-bold sp-service"
            v-model="selected"
            value="SPOptions"
            name="choose-delivery"
            @click.native="$root.$emit('bv::show::modal', 'sp-services-modal')">
            You can send your shipment by
            {{ cheapDelivery.serviceName }}
            <span class="text-user-primary">
                 {{cheapDelivery.price}}
                 {{cheapDelivery.currencyCode}}
                 <small v-if="cheapDelivery.vat > 0">+ VAT</small>
            </span>
            <small>({{cheapDelivery.currencyCode}} {{cheapDelivery.totalPrice}})</small>
            <img class="sp-service-logo default-service-logo"
                 :src="cheapDelivery.serviceImageUrl"
                 alt="send-parcel-logo-color">
        </b-form-radio>
        <transition name="fade">
            <div class="pl-4 sp-service" v-if="selected === 'SPOptions'">
                <div class="row pt-3">
                    <div class="col-sm-4">
                        <date-list
                            :clearable="false"
                            :options="dates"
                            v-model="selectedDate"
                            label="label"
                        />
                    </div>
                </div>
            </div>
        </transition>
        <b-form-radio
            class="mb-2 mt-4 font-weight-bold"
            v-model="selected"
            name="choose-delivery"
            value="otherCompany">
            <h5 class="font-weight-bold">Other currier company</h5>
        </b-form-radio>
        <div class="pl-4">
            <div class="row mb-2">
                <div class="col-sm-3">
                    <b-form-input
                        v-model="otherCurrier.name"
                        :disabled="selected !== 'otherCompany'"
                        placeholder="Company name"/>
                </div>
                <div class="col-sm-4">
                    <b-form-input
                        v-model="otherCurrier.trackingNumber"
                        :disabled="selected !== 'otherCompany'"
                        placeholder="Tracking Number"/>
                </div>
            </div>
        </div>
        <b-form-radio
            class="mb-2 mt-4"
            v-model="selected"
            name="choose-delivery"
            value="yourself">
            <span class="h5 font-weight-bold">You can deliver it by yourself</span>
        </b-form-radio>
        <div class="d-flex">
            <b-btn variant="primary-user"
                   class="ml-auto"
                   size="sm"
                   :disabled="$store.state.loading || !selected"
                   @click="setDelivery">
                Create shipment
            </b-btn>
        </div>
        <sp-services-modal
            :id="$route.params.planId"
            :preferableDelivery="null"
            :minInsurancePrice="0"
            :items="sendParcelOptions"
            @resetSelected="selected = ''"
            @setDelivery="(payload) => selectedSP = payload.serviceId"
        ></sp-services-modal>
    </div>
</template>

<script>
    import { getWorkingDays } from '@/utils'
    import DateList from 'vue-select'

    export default {
        name: 'Step3',
        components: {
            DateList,
            SpServicesModal: () => import('./SPServicesModal')
        },
        data() {
            return {
                dates: [],
                selected: '',
                selectedSP: '',
                selectedDate: null,
                otherCurrier: {
                    name: '',
                    trackingNumber: '',
                },
                sendParcelOptions: [],
                loading: true
            }
        },
        watch: {
            'selected': function(newVal) {
                if (newVal === 'SPOptions') {
                    this.$root.$emit('bv::show::modal', 'sp-services-modal')
                    this.selectedSP = this.renderSendParcel.serviceId
                } else {
                    this.selectedSP = ''
                }
                this.otherCurrier = {
                    name: '',
                    trackingNumber: '',
                }
            }
        },
        computed: {
            validateCompany() {
                if (!this.otherCurrier.name && !this.otherCurrier.trackingNumber) {
                    return false
                }
            },
            cheapDelivery() {
                let list = [...this.sendParcelOptions]
                return list.sort((a, b) => {
                    if (a.price < b.price) return -1
                    return a.price > b.price ? 1 : 0
                })[0]
            }
        },
        mounted() {
            this.getDelivery()
            this.dates = getWorkingDays(new Date(), 5)
            this.selectedDate = this.dates[0]
        },
        methods: {
            getDelivery() {
                this.$api('GET', this.$endpoints.incomesDeliveryOffers(this.$route.params.planId)).then(response => {
                    this.sendParcelOptions = response
                }).finally(() => {
                    this.loading = false
                })
            },
            setDelivery() {
                let params = {}
                switch (this.selected) {
                    case 'SPOptions':
                        params = {
                            serviceCode: this.selectedSP,
                            pickUpDate: this.selectedDate.code
                        }
                        break
                    case 'otherCompany':
                        params = {
                            serviceCode: this.selected,
                            companyName: this.otherCurrier.name,
                            trackingNumber: this.otherCurrier.trackingNumber
                        }
                        break
                    case 'yourself':
                        params.serviceCode = this.selected
                        break
                }
                this.$api('POST', this.$endpoints.incomesApplyDelivery(this.$route.params.planId), null, params)
                    .then(response => this.$router.push({
                        name: 'Step4',
                        params: {planData: response}
                    }))
            },
        }
    }
</script>
<style lang="scss">
    @import "~@/assets/style/utils/_variables.scss";

    $vdpColor: $accent-color-user;
    @import '~vue-date-pick/src/vueDatePick.scss';
    .vdpComponent {
        .vdpHeader {
            background: $accent-color-user;
            margin-bottom: -3.2em;
        }

        .vdpPeriodControl {
            & > button {
                font-weight: bold;
                color: $text-dark-color-user;
                font-size: 1.2rem;
            }
        }

        .vdpHeadCell {
            .vdpHeadCellContent {
                font-weight: bold;
                color: $text-dark-color-user;
                font-size: 14px;
                padding-bottom: 10px;
            }

        }

        .vdpCellContent {
            font-weight: 600;
            font-size: 16px;
        }

        .vdpArrow {
            &:before {
                width: 3.2em;
                height: 3.2em;
                border: 1px solid rgba(black, .25);
                margin-top: -1.5em;
                // background-color: black;
            }

            &:after {
                margin-top: -0.4em;
            }

            &.vdpArrowPrev {
                &:after {
                    margin-left: -0.4em;
                    border-right-color: $text-dark-color-user;
                }
            }

            &.vdpArrowNext {
                &:before {
                    margin-left: -2.2em;
                }

                &:after {
                    margin-left: -0.75em;
                    border-left-color: $text-dark-color-user;
                }
            }
        }
    }
    .sp-service {
        small {
            font-size: 75%;
            font-weight: bold;
        }
        &-logo {
            max-width: 100px;
            width: 100%;
            margin-left: .5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/CreateShipment/Step3.vue